Ext.define('SA.Loader', {
    singleton: true,

    extractProjectLocationSeries({projectData}) {
        return projectData
            .map(project => project.locationItems)
            .flat()
            .filter(locationItem => locationItem.type === 'locationSeries')
            .map(locationItem => locationItem.id);
    },

    async load() {
        var systemPromise = SA.model.System.initialize(),
            institutionPromise = this.loadInstitution(),
            projectDataPromise = SA.Ajax.request({resource: 'user/projects'}),
            locationAliasesPromise = SA.data.LocationAliases.loadAll(),
            vendorsPromise = Promise.all([systemPromise, institutionPromise]).then(() => {
                var datasetFactory = new SA.data.DatasetFactory({currentYear: SA.System.getYear()});

                return SA.data.Vendors.loadAll({datasetFactory});
            }),
            loadAttributesPromise = Promise.all([projectDataPromise, institutionPromise, vendorsPromise]).then(([projectData]) => this.loadAttributes(projectData)),
            loadLocationsPromise = Promise.all([projectDataPromise, institutionPromise, locationAliasesPromise]).then(([projectData]) => this.loadLocations(projectData)),
            deserializeProjectsPromise = Promise.all([
                projectDataPromise,
                institutionPromise,
                loadAttributesPromise,
                loadLocationsPromise
            ]).then(([projectData]) => SA.data.Projects.deserialize(projectData));

        await Promise.all([
            SA.model.User.build(),

            institutionPromise.then(() => Promise.all([
                SA.data.DataCategories.loadAll(),
                vendorsPromise,
                SA.data.Years.loadAll()
            ])),

            SA.data.SicCodes.loadAll(),
            SA.data.NaicsCodes.loadAll(),
            SA.data.BusinessSearches.loadAll({projectsReadyPromise: deserializeProjectsPromise}),
            SA.data.ColorScheme.loadAll()
        ]);
    },

    async loadAttributes(projectData) {
        var projectAttributeIds = projectData.flatMap(data => data.attributes),
            load = ids => SA.data.AttributesCache.getPromise(ids),
            getUserAttributeIds = () => SA.data.UserImports.loadAll(),
            getNewProjectAttributeIds = () => SA.data.NewProjectAttributes.loadAll();

        await load(await getUserAttributeIds());
        await load(SA.Array.unique([await getNewProjectAttributeIds(), projectAttributeIds]));
    },

    async loadInstitution() {
        var {name, locale, countries, userAuthenticationMethod} = await SA.Ajax.request({resource: 'institution'}),
            countries = SA.Object.mapValues(countries, (data, code) => SA.CountryFactory.create({code, data}));

        SA.Institution = new SA.model.Institution({name, locale, countries, userAuthenticationMethod});
    },

    async loadLocations(projectData) {
        await SA.data.CustomLocations.loadAll();

        var projectSeries = this.extractProjectLocationSeries({projectData}),
            countrySeries = SA.Institution.getLocationSeriesForCountries(),
            customSeries = SA.data.CustomLocations.getAllSeries(),
            allSeries = SA.Array.unique([customSeries, countrySeries, projectSeries].flat());

        return SA.data.LocationsCache.getPromise(allSeries);
    }
});